import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface DonationStats {
  thisMonth: number;
  lastMonth: number;
  diffFromLastMonth: number;
  monthOverMonth: "increased" | "decreased" | "same";
  last30DaysAvgPerDay: number;
  avgComparedToLastMonth: "increased" | "decreased" | "same";
  mostDonatedBloodType: { type: string; count: number } | null;
  leastDonatedBloodType: { type: string; count: number } | null;
}

export interface DonorStats {
  totalDonors: number;
  totalDonations: number;
  inactiveDonors90d: number;
  inactiveDonorsLastYear: number;
  activeDonorsThisMonth: number;
  activeDonorsPercent: number;
  avgDonationsPerDonor: number;
  atRiskCount: number;
}

export interface InactiveDonor {
  id: string;
  name: string;
  email: string;
  nic: string;
  bloodGroup: string;
  createdAt: string;
  totalDonations: number;
  phoneNumber: string | null;
  city: string | null;
  district: string | null;
  lastDonationDate: string | null;
}

export const donationReportsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDonationStats: builder.query<DonationStats, void>({
      query: () => "/donation-reports/stats",
      transformResponse: (res: ApiResponse<DonationStats>) => res.data,
      providesTags: ["DonationReports"],
    }),
    getDonorStats: builder.query<DonorStats, void>({
      query: () => "/donation-reports/donors/stats",
      transformResponse: (res: ApiResponse<DonorStats>) => res.data,
      providesTags: ["DonationReports"],
    }),
    getInactiveDonors: builder.query<{ donors: InactiveDonor[]; pagination: { page: number; limit: number } }, { page?: number; limit?: number }>({
      query: ({ page, limit }) => `/donation-reports/donors/inactive?page=${page ?? 1}&limit=${limit ?? 20}`,
      transformResponse: (res: ApiResponse<{ donors: InactiveDonor[]; pagination: { page: number; limit: number } }>) => res.data,
      providesTags: ["DonationReports"],
    }),
  }),
});

export const { useGetDonationStatsQuery, useGetDonorStatsQuery, useGetInactiveDonorsQuery } = donationReportsApi;
